import { IconTypes } from '@app/ui'
import { ToggleOption, DateOption } from './types'
import { generateDateOptions } from './helpers'

export const TIP_TYPE_OPTIONS: ToggleOption[] = [
  { id: 1, label: 'All', value: 'All' },
  { id: 2, label: 'Single', value: 'Single' },
  { id: 3, label: 'Multi', value: 'Multi' }
]

export const ANALYSIS_OPTIONS: ToggleOption[] = [
  { id: 1, label: 'All', value: null },
  { id: 2, label: 'Yes', value: true },
  { id: 3, label: 'No', value: false }
]

export const DATE_OPTIONS: DateOption[] = generateDateOptions()

export const SPORT_ICON_MAP: Record<string, IconTypes> = {
  'Football': IconTypes.football,
  'Basketball': IconTypes.basketball,
  'Tennis': IconTypes.tennis,
  'Hockey': IconTypes.hockey,
  'Handball': IconTypes.handball,
  'Volleyball': IconTypes.volleyball,
  'American Football': IconTypes.americanFootball,
  'Baseball': IconTypes.baseball,
  'Cricket': IconTypes.cricket,
  'Rugby': IconTypes.rugby,
  'Rugby league': IconTypes.rugbyLeague,
  'Boxing': IconTypes.boxing,
  'Esports': IconTypes.eSports,
  'MMA': IconTypes.mma,
  'Table Tennis': IconTypes.tableTennis,
}
